import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { map, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class Form1118SchdJService {

  constructor(private http: HttpClient) { }

  /**
   * Check lock status for tax return
   * Action Code: 'n10cpv'
   */
  checkLockStatus(
    baseUrl: string,
    p_scenario: string,
    p_jcd_key: string,
    globalService: any,
    filterParams: any = {}
  ): Observable<any> {
    return this._makeLoadRequest(baseUrl, {
      action_code: 'n10cpv',
      p_scenario: p_scenario || filterParams?.scenario || globalService?.scenario || globalService?.globalParams?.scenario || '',
      p_jcd_key: p_jcd_key || filterParams?.jcd_key || globalService?.jcd_key || globalService?.globalParams?.jcd_key || '',
      tax_year: filterParams?.tax_year || globalService?.tax_year || globalService?.globalParams?.tax_year || '',
      scenario: filterParams?.scenario || globalService?.scenario || globalService?.globalParams?.scenario || '',
      jcd_key: filterParams?.jcd_key || globalService?.jcd_key || globalService?.globalParams?.jcd_key || '',
      screen_key: filterParams?.screen_key || globalService?.screen_key || globalService?.globalParams?.screen_key || '',
      jcd_ta_key: filterParams?.jcd_ta_key || globalService?.jcd_ta_key || globalService?.globalParams?.jcd_ta_key || '',
      activity_key: filterParams?.activity_key || globalService?.activity_key || globalService?.globalParams?.activity_key || '',
      screen_type: filterParams?.screen_type || globalService?.screen_type || globalService?.globalParams?.screen_type || 'grid',
      is_locked: filterParams?.is_locked || globalService?.is_locked || globalService?.globalParams?.is_locked || 'N',
      issue_id: filterParams?.issue_id || globalService?.issue_id || globalService?.globalParams?.issue_id || '',
      issue_short_desc: filterParams?.issue_short_desc || globalService?.issue_short_desc || globalService?.globalParams?.issue_short_desc || '',
      issue_id_for_tx_save: filterParams?.issue_id_for_tx_save || globalService?.issue_id_for_tx_save || globalService?.globalParams?.issue_id_for_tx_save || '',
      scenarioCode: filterParams?.scenarioCode || filterParams?.scenario_code || globalService?.scenarioCode || globalService?.scenario_code || 'RAF',
      is_issue_key_enabled: filterParams?.is_issue_key_enabled || globalService?.is_issue_key_enabled || globalService?.globalParams?.is_issue_key_enabled || 'N'
    });
  }

  /**
   * Get Scenario Dropdown
   * Action Code: '7q0wiy'
   */
  getScenarioDropDown(
    baseUrl: string,
    taxYear: string,
    globalService: any,
    filterParams: any = {}
  ): Observable<any> {
    return this._makeLoadRequest(baseUrl, {
      action_code: '7q0wiy',
      tax_year: taxYear,
      scenario: filterParams?.scenario || globalService?.scenario || globalService?.globalParams?.scenario || '',
      jcd_key: filterParams?.jcd_key || globalService?.jcd_key || globalService?.globalParams?.jcd_key || '',
      screen_key: filterParams?.screen_key || globalService?.screen_key || globalService?.globalParams?.screen_key || '',
      jcd_ta_key: filterParams?.jcd_ta_key || globalService?.jcd_ta_key || globalService?.globalParams?.jcd_ta_key || '',
      activity_key: filterParams?.activity_key || globalService?.activity_key || globalService?.globalParams?.activity_key || ''
    });
  }

  /**
   * Get Filing Group Dropdown
   * Action Code: '0udsuc'
   */
  getFilingGroupDropdown(
    baseUrl: string,
    taxYear: string,
    scenario: string,
    globalService: any,
    filterParams: any = {}
  ): Observable<any> {
    return this._makeLoadRequest(baseUrl, {
      action_code: '0udsuc',
      tax_year: taxYear,
      scenario: scenario,
      jcd_key: filterParams?.jcd_key || globalService?.jcd_key || globalService?.globalParams?.jcd_key || '',
      screen_key: filterParams?.screen_key || globalService?.screen_key || globalService?.globalParams?.screen_key || '',
      jcd_ta_key: filterParams?.jcd_ta_key || globalService?.jcd_ta_key || globalService?.globalParams?.jcd_ta_key || '',
      activity_key: filterParams?.activity_key || globalService?.activity_key || globalService?.globalParams?.activity_key || ''
    });
  }

  /**
   * Get Filer Entity Dropdown
   * Action Code: '35gc5l'
   */
  getFilerEntityDropdown(
    baseUrl: string,
    taxYear: string,
    scenario: string,
    filingGroupKey: string,
    globalService: any,
    filterParams: any = {}
  ): Observable<any> {
    return this._makeLoadRequest(baseUrl, {
      action_code: '35gc5l',
      tax_year: taxYear,
      scenario: scenario,
      filing_group_key: filingGroupKey,
      jcd_key: filterParams?.jcd_key || globalService?.jcd_key || globalService?.globalParams?.jcd_key || '',
      screen_key: filterParams?.screen_key || globalService?.screen_key || globalService?.globalParams?.screen_key || '',
      jcd_ta_key: filterParams?.jcd_ta_key || globalService?.jcd_ta_key || globalService?.globalParams?.jcd_ta_key || '',
      activity_key: filterParams?.activity_key || globalService?.activity_key || globalService?.globalParams?.activity_key || ''
    });
  }

  /**
   * Get Form Column Descriptions for Schedule J
   * Action Code: 'v3uakt'
   */
  getFormColumnDescriptions(
    baseUrl: string,
    taxYear: string,
    globalService: any,
    filterParams: any = {}
  ): Observable<any> {
    return this._makeLoadRequest(baseUrl, {
      action_code: 'v3uakt',
      tax_year: taxYear,
      scenario: filterParams?.scenario || globalService?.scenario || globalService?.globalParams?.scenario || '',
      jcd_key: filterParams?.jcd_key || globalService?.jcd_key || globalService?.globalParams?.jcd_key || '',
      screen_key: filterParams?.screen_key || globalService?.screen_key || globalService?.globalParams?.screen_key || '',
      jcd_ta_key: filterParams?.jcd_ta_key || globalService?.jcd_ta_key || globalService?.globalParams?.jcd_ta_key || '',
      activity_key: filterParams?.activity_key || globalService?.activity_key || globalService?.globalParams?.activity_key || ''
    });
  }

  /**
   * Get Form Lines and Descriptions for Schedule J
   * Action Code: 'uhmejk'
   */
  getFormLinesAndDescriptions(
    baseUrl: string,
    basket: string,
    taxYear: string,
    scenario: string,
    filerEntityKey: string,
    globalService: any,
    filterParams: any = {}
  ): Observable<any> {
    return this._makeLoadRequest(baseUrl, {
      action_code: 'uhmejk',
      basket: basket,
      tax_year: taxYear,
      scenario: scenario,
      filer_entity_key: filerEntityKey,
      jcd_key: filterParams?.jcd_key || globalService?.jcd_key || globalService?.globalParams?.jcd_key || '',
      screen_key: filterParams?.screen_key || globalService?.screen_key || globalService?.globalParams?.screen_key || '',
      jcd_ta_key: filterParams?.jcd_ta_key || globalService?.jcd_ta_key || globalService?.globalParams?.jcd_ta_key || '',
      activity_key: filterParams?.activity_key || globalService?.activity_key || globalService?.globalParams?.activity_key || ''
    });
  }

  /**
   * Save Schedule J Basket Amounts
   * Action Code: 'ng6tfg'
   *
   * Builds FormData directly (matching AngularJS Form1118SchdJFactory.saveBasketAmounts):
   *   1. Start with GlobalService.globalParams
   *   2. Merge isIssueIDEnabled(tax_year, scenario)
   *   3. Add clob_data (JSON stringified Details) and clob_settings (JSON stringified _data)
   *   4. Override jcd_key, tax_year, scenario, filer_entity_key
   *   5. Build checkLockedbj from filer_combination_key
   *   6. POST as FormData (Angular equivalent of AngularJS x-www-form-urlencoded)
   *
   * NOTE: Does NOT use JsonObjectFactoryService.saveJSON() because that method
   * requires a live workspaceFactory reference (with activeScreen, filters, data)
   * which is unavailable in the custom element context (globalService is a parsed
   * JSON header without AngularJS service references).
   */
  saveBasketAmounts(
    baseUrl: string,
    returnClobSettingsObj: any,
    dataToSave: any[],
    taxYear: string,
    scenario: string,
    filerEntityKey: string,
    filerCombinationKey: string,
    jcdKey: string,
    globalService: any,
    filterParams: any = {}
  ): Observable<any> {
    const url = `${baseUrl}/saveJsonObject?action_code=ng6tfg`;

    const jsonObj = JSON.stringify(dataToSave);
    const jsonSettings = JSON.stringify(returnClobSettingsObj);

    // 1. Start with globalParams (matching: params = _.merge({}, GlobalService.globalParams, params))
    const params: any = {};
    if (globalService?.globalParams) {
      Object.assign(params, globalService.globalParams);
    }

    // 2. Merge isIssueIDEnabled (matching: params = _.merge({}, isIssueIdEnabled, params))
    // scenarioCode and is_issue_key_enabled are pre-computed in the AngularJS controller
    // and passed via filterParams (same pattern as form-1118-ftc-edit, expense-trans-add-edit)
    params.scenarioCode = filterParams?.scenarioCode || filterParams?.scenario_code || params.scenarioCode || 'RAF';
    params.is_issue_key_enabled = filterParams?.is_issue_key_enabled || params.is_issue_key_enabled || 'N';

    // 3. Add clob_data and clob_settings
    params.clob_data = jsonObj;
    params.clob_settings = jsonSettings;

    // 4. Override specific keys
    params.jcd_key = jcdKey;
    params.tax_year = taxYear;
    params.scenario = scenario;
    params.filer_entity_key = filerEntityKey;

    // 5. Build checkLockedbj (matching: setLockObj(filer_combination_key))
    const checkLockObj = [{ combination_key: filerCombinationKey }];
    params.checkLockedbj = JSON.stringify(checkLockObj);

    // 6. Build FormData and POST
    const formData = new FormData();
    Object.keys(params).forEach(key => {
      if (params[key] !== null && params[key] !== undefined && params[key] !== '') {
        formData.append(key, params[key]);
      }
    });

    return this.http.post(url, formData).pipe(
      map((response: any) => response)
    );
  }

  /**
   * Private helper method to make load HTTP request
   */
  private _makeLoadRequest(baseUrl: string, params: any): Observable<any> {
    const urlParams = new URLSearchParams();
    Object.keys(params).forEach(key => {
      if (params[key] !== undefined && params[key] !== null) {
        urlParams.set(key, params[key].toString());
      }
    });

    const url = `${baseUrl}/loadJsonObject?${urlParams.toString()}`;

    const headers = new HttpHeaders({
      'Content-Type': 'application/x-www-form-urlencoded'
    });

    return this.http.post<any>(url, '', { headers, withCredentials: true });
  }
}
